import { combineReducers } from 'redux'
import userReducer from './userReducer'
import teamReducer from './teamReducer'
import companyReducer from './comapnyReducer'
import companyArrReducer from './companyArrReducer'
import industryArrReducer from './industryArrReducer'
import industryReducer from './industryReducer'
import sidebarReducer from "./sidebarReducer"
import notificationReducer from './notificationReducer'
import routeTrackingReducer from './routeTrackingReducer'
import accordianReducer from "./accordianReducer"
import languageReducer from "./languageReducer"
import reducer from './reducer'
    
export default combineReducers({userReducer,teamReducer,reducer,companyArrReducer,companyReducer,industryArrReducer,industryReducer,sidebarReducer,notificationReducer,routeTrackingReducer,accordianReducer,languageReducer})